<template>
  <div class="margin-top">
    <div class="label-input">{{ $t('foodSamples.parameter') }}</div>
    <div class="marginTop5">
      <DxTagBox
        :data-source="parameterTypes"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('foodSamples.parameter')"
        tag-template="tag"
        display-expr="value"
        value-expr="id"
        :value="selectedParameters"
        :on-value-changed="parametersChanged"
        :on-opened="openedParameters"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>

    <div class="margin-top-half label-input">{{ $t('group') }}</div>
    <div class="marginTop5">
      <DxTagBox
        :data-source="parameterGroups"
        :multiline="true"
        :search-enabled="true"
        :placeholder="$t('group')"
        tag-template="tag"
        display-expr="value"
        value-expr="id"
        :value="selectedParameterGroups"
        :on-value-changed="parameterGroupChanged"
        :on-opened="openedParameterGroup"
        :on-content-ready="contentReady"
        :show-selection-controls="true"
      >
        <template #tag="{ data }">
          <div class="purpleTag">
            <b>{{ data.value }}</b>
            <div class="dx-tag-remove-button xButton"></div>
          </div>
        </template>
      </DxTagBox>
    </div>
  </div>
</template>

<script>
import { DxTagBox } from 'devextreme-vue/tag-box';
import { mapActions, mapState } from 'vuex';
import DataSource from 'devextreme/data/data_source';

export default {
  name: 'MiningDetailsFilter',
  components: {
    DxTagBox,
  },
  data() {
    return {
      parameterTypes: [],
      parameterGroups: [],
      loaded: false,
    };
  },
  computed: {
    ...mapState('miningSamples', ['sampleDetails']),
    ...mapState('miningDetailsFilter', [
      'selectedParameters',
      'selectedParameterGroups',
    ]),
    ...mapState('filter', ['currentSampleId']),
  },
  methods: {
    async openedParameters(e) {
      const parameters = await this.getSampleFilter({
        atc: 'Minería',
        attribute: 'parameter',
        sampleId: this.currentSampleId,
      });

      this.parameterTypes = new DataSource({
        store: parameters,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    async openedParameterGroup(e) {
      const parameters = await this.getSampleFilter({
        atc: 'Minería',
        attribute: 'parameter_group',
        sampleId: this.currentSampleId,
      });

      this.parameterGroups = new DataSource({
        store: parameters,
        key: '',
        paginate: true,
        pageSize: 10,
      });
      this.loaded = true;
    },
    contentReady(e) {
      const arrayNotFoundItems = Array.from(
        document.getElementsByClassName('dx-empty-message')
      );

      arrayNotFoundItems.forEach((element) => {
        if (!this.loaded) {
          element.innerHTML = this.$t('loading');
        } else {
          element.innerHTML = this.$t('dataNotAvailable');
        }
      });

      this.loaded = false;
    },
    parametersChanged(e) {
      this.setSelectedParameters(e.value);
    },
    parameterGroupChanged(e) {
      this.setSelectedParameterGroup(e.value);
    },
    ...mapActions('miningDetailsFilter', [
      'setSelectedParameters',
      'setSelectedParameterGroup',
    ]),
    ...mapActions('samples', ['getSampleFilter']),
  },
};
</script>
